var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header width-control text-center"},[_c('img',{attrs:{"src":require("@/assets/img/logo/logo.png"),"alt":"logo-salute"}})])
}]

export { render, staticRenderFns }